"use client"

import Image from "next/image"
import { motion, useReducedMotion } from "framer-motion"
import { useState } from "react"

export function YouTubeLite() {
  const [isLoaded, setIsLoaded] = useState(false)
  const reduceMotion = useReducedMotion()

  return (
    <div className="relative aspect-[4/3] w-full overflow-hidden rounded-[1.5rem] bg-muted">
      {isLoaded ? (
        <iframe
          className="absolute inset-0 h-full w-full rounded-[1.5rem]"
          src="https://www.youtube.com/embed/Pv_M1RiOnpw?autoplay=1&rel=0"
          title="Ashley Carter Youngblood at Inner Peace Counseling, PLC - Kalamazoo holistic therapist"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ) : (
        <motion.button
          type="button"
          aria-label="Play Ashley Carter Youngblood introduction video"
          onClick={() => setIsLoaded(true)}
          className="group absolute inset-0 overflow-hidden rounded-[1.5rem] bg-muted text-left focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-4 focus:ring-offset-card"
          whileHover={reduceMotion ? undefined : { scale: 1.008 }}
          whileTap={reduceMotion ? undefined : { scale: 0.985 }}
        >
          <Image
            src="/images/ashley-intro-video-poster.jpg"
            alt="Ashley Carter Youngblood introduction video poster"
            fill
            className="object-cover transition duration-700 group-hover:scale-[1.035]"
            sizes="(min-width: 1024px) 46vw, 100vw"
          />
          <div className="absolute inset-0 bg-[linear-gradient(180deg,hsl(var(--foreground)/0.02)_0%,hsl(var(--foreground)/0.08)_48%,hsl(var(--foreground)/0.42)_100%)]" />
          <div aria-hidden="true" className="absolute -left-20 top-8 h-56 w-56 rounded-full bg-primary/24 blur-3xl transition duration-500 group-hover:scale-110" />
          <div aria-hidden="true" className="absolute -right-12 bottom-0 h-64 w-64 rounded-full bg-primary-glow/28 blur-3xl transition duration-500 group-hover:scale-110" />

          <div className="absolute inset-0 flex items-center justify-center">
            <span className="relative flex size-20 items-center justify-center rounded-full border border-background/45 bg-background/82 text-primary shadow-theme-elegant backdrop-blur-xl transition duration-300 group-hover:scale-105 group-hover:bg-background focus:outline-none">
              <motion.span
                aria-hidden="true"
                className="absolute inset-0 rounded-full border border-primary/35"
                animate={reduceMotion ? undefined : { scale: [1, 1.22, 1], opacity: [0.5, 0, 0.5] }}
                transition={{ duration: 2.4, ease: "easeInOut", repeat: Infinity }}
              />
              <span aria-hidden="true" className="relative ml-1 text-3xl transition-transform duration-300 group-hover:translate-x-0.5">▶</span>
            </span>
          </div>

        </motion.button>
      )}
    </div>
  )
}
